import { createI18n } from 'vue-i18n'
import en from '@/locales/en.json'
import es from '@/locales/es.json'
import ru from '@/locales/ru.json'
import kz from '@/locales/kz.json'
import pt from '@/locales/pt.json'
import de from '@/locales/de.json'
import fr from '@/locales/fr.json'
import it from '@/locales/it.json'
import rm from '@/locales/rm.json'

const i18n = createI18n({
  legacy: false,
  locale: 'en',
  fallbackLocale: 'en',
  messages: { en, es, ru, kz, pt, de, fr, it, rm },
})

export default i18n
